import http from './api.service';

class PreferencesService {
    getPreferencesFilters(userId: string, prefType) {
        return http.get('/preference/filter', {
            params: {
                userId: userId,
                prefType: prefType
            }
        });
    }

    savePreferenceFilter(filters, userId: string, prefType: string) {
        return http.post('/preference/filter', filters,
            {
                headers: {'Content-Type': 'application/json'},
                params: {
                    userId: userId,
                    prefType: prefType
                }
            });
    }

    deletePreferenceFilter(uuid: string, userId) {
        return http.delete('/preference/filter/' + uuid, {params: {userId: userId}});
    }

    getPreferencesFiles(userId, prefType) {
        return http.get('/preference/filerepeller', {params: {userId: userId, prefType: prefType}});
    }

    deletePreferenceFiles(uuid: string, userId) {
        return http.delete('/preference/filerepeller/' + uuid, {params: {userId: userId}});
    }

    updateFileRepellerIdentifier(uuid: string, identifier: any | any[], userId) {
        return http.post('/preference/filerepeller/' + uuid, identifier, {
            headers: {'Content-Type': 'application/json'},
            params: {userId: userId}
        });
    }

    uploadFileRepeller(file: File, userId, prefType) {
        return http.post('/preference/filerepeller', {filename: file.name, type: file.type},
            {
                headers: {'Content-Type': 'application/json'},
                params: {
                    userId: userId,
                    prefType: prefType
                }
            }).then((res) => {
            const formData = new FormData();
            formData.append("file", file);
            return http.put(res.data.presignedURL, file, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(() => {
                return http.post('/preference/filerepeller', {
                    userId: userId,
                    id: res.data.id,
                    fileName: file.name,
                    type: file.type
                }, {
                    headers: {'Content-Type': 'application/json'}
                });
            }).then(() => {
                return res;
            });
        });
    }

    fileCheck(userId, uuid) {
        return http.get('/preference/check/' + uuid, {params: {userId: userId}});
    }

    previewFile(id) {
        return http.get('/preference/filerepeller/' + id + '/preview');
    }

    getFile(fileId, userId) {
        const params = new URLSearchParams();
        params.append('fileId', fileId);
        return http.get('/preference/filerepeller/' + fileId, {params: {userId: userId}});
    }
}

export default new PreferencesService();
